/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsIndentArrowRight: {
  name: 'indent-arrow-right';
  data: string;
} = {
  name: 'indent-arrow-right',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm4.293 3.293a1 1 0 0 1 1.414 0l2 2a1 1 0 0 1 0 1.414l-2 2a1 1 0 0 1-1.414-1.414L7.586 13H4a1 1 0 1 1 0-2h3.586l-.293-.293a1 1 0 0 1 0-1.414ZM4 17a1 1 0 1 0 0 2h16a1 1 0 1 0 0-2H4Zm8-3a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2h-7a1 1 0 0 1-1-1Zm1-5a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2h-7Z" fill="currentColor"/></svg>`,
};
